import React from 'react';
import { RootStack } from 'src/navigation/RootNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
export const renderSTCStackRoutes = () => {
    return (React.createElement(RootStack.Group, null,
        React.createElement(RootStack.Screen, { name: "STC_Home", component: Home })));
};
